<button mat-button class="decline-btn" (click)="openDeclineDialog()" data-cy="decline-app-btn">
	Decline App
</button>